import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f26eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }

import { computed, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import type { Mode } from '@/types/mobile'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import MobileThumbnails from './MobileThumbnails.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MobilePlayer',
  props: {
    changeMode: { type: Function }
  },
  setup(__props: any) {



const slidesStore = useSlidesStore()
const { slides, slideIndex, currentSlide, viewportRatio } = storeToRefs(slidesStore)

const toolVisible = ref(false)

const playerSize = ref({ width: 0, height: 0 })

onMounted(() => {
  if (slideIndex.value !== 0) slidesStore.updateSlideIndex(0)

  playerSize.value = {
    width: document.body.clientHeight,
    height: document.body.clientWidth,
  }
})

const slideSize = computed(() => {
  const playerRatio = playerSize.value.height / playerSize.value.width

  let slideWidth = 0
  let slideHeight = 0

  if (playerRatio >= viewportRatio.value) {
    slideWidth = playerSize.value.width
    slideHeight = slideWidth * viewportRatio.value
  }
  else {
    slideHeight = playerSize.value.height
    slideWidth = slideHeight / viewportRatio.value
  }

  return {
    width: slideWidth,
    height: slideHeight,
  }
})

const touchInfo = ref<{ x: number; y: number; } | null>(null)
const touchStartListener = (e: TouchEvent) => {
  touchInfo.value = {
    x: e.changedTouches[0].pageX,
    y: e.changedTouches[0].pageY,
  }
}
const touchEndListener = (e: TouchEvent) => {
  if (!touchInfo.value) return

  const offsetY = Math.abs(touchInfo.value.y - e.changedTouches[0].pageY)
  const offsetX = e.changedTouches[0].pageX - touchInfo.value.x

  if ( Math.abs(offsetX) > offsetY && Math.abs(offsetX) > 50 ) {
    touchInfo.value = null

    if (offsetX < 0 && slideIndex.value > 0) slidesStore.updateSlideIndex(slideIndex.value - 1)
    if (offsetX > 0 && slideIndex.value < slides.value.length - 1) slidesStore.updateSlideIndex(slideIndex.value + 1)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_IconLogout = _resolveComponent("IconLogout")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-player",
    style: _normalizeStyle({
      width: playerSize.value.width + 'px',
      height: playerSize.value.height + 'px',
      transform: `rotate(90deg) translateY(-${playerSize.value.height}px)`,
    })
  }, [
    _createElementVNode("div", {
      class: "screen-slide-list",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toolVisible.value = !toolVisible.value)),
      onTouchstart: _cache[1] || (_cache[1] = $event => touchStartListener($event)),
      onTouchend: _cache[2] || (_cache[2] = $event => touchEndListener($event))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([
          'slide-item', 
          `turning-mode-${slide.turningMode || 'slideY'}`,
          {
            'current': index === _unref(slideIndex),
            'before': index < _unref(slideIndex),
            'after': index > _unref(slideIndex),
            'hide': (index === _unref(slideIndex) - 1 || index === _unref(slideIndex) + 1) && slide.turningMode !== _unref(currentSlide).turningMode,
          }
        ]),
          key: slide.id
        }, [
          (Math.abs(_unref(slideIndex) - index) < 2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "slide-content",
                style: _normalizeStyle({
            width: slideSize.value.width + 'px',
            height: slideSize.value.height + 'px',
          })
              }, [
                _createVNode(ThumbnailSlide, {
                  slide: slide,
                  size: slideSize.value.width
                }, null, 8, ["slide", "size"])
              ], 4))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 32),
    (toolVisible.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "back",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeMode('preview')))
            }, [
              _createVNode(_component_IconLogout),
              _createTextVNode(" 退出播放")
            ])
          ]),
          _createVNode(MobileThumbnails, { class: "thumbnails" })
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}
}

})